const KeenSlider = window.KeenSlider
const { setInitialised, useDots } = window.BAO.Carousel.plugins

class QuickBuyModalImageCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    this.setupCarousel()
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.destroyCarousel()
  }

  setupCarousel () {
    const slideCount = this.els.slides.element.children.length

    if (slideCount <= 1) {
      this.setAttribute('data-initialised', 'false')
      return
    }

    const dots = Array.from(this.els.dots.element.children)

    this.carousel = new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1,
          spacing: 2,
        },
        dragStarted: () => {
          this.els.slides.element.classList.add('qb-QuickBuy_Slides-dragging')
        },
        dragEnded: () => {
          this.els.slides.element.classList.remove(
            'qb-QuickBuy_Slides-dragging',
          )
        },
      },
      [setInitialised(), useDots(dots)],
    )

    this.setAttribute('data-initialised', 'true')
  }

  destroyCarousel () {
    if (this.carousel) {
      this.carousel.destroy()
      this.carousel = null

      this.setAttribute('data-initialised', 'false')
    }
  }
}

if (!customElements.get('quick-buy-modal-image-carousel')) {
  customElements.define(
    'quick-buy-modal-image-carousel',
    QuickBuyModalImageCarousel,
  )
}
